var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49 4.6265C9.30098 4.14751 9.01559 3.71245 8.65152 3.34829C8.28744 2.98413 7.85245 2.69863 7.3735 2.5095C7.2604 2.63788 7.1701 2.78466 7.1065 2.9435C7.55429 3.10629 7.96094 3.36525 8.29785 3.70215C8.63475 4.03906 8.89372 4.44572 9.0565 4.8935C9.21534 4.8299 9.36212 4.7396 9.4905 4.6265M6.1145 2.7515L6 2.75C5.35236 2.75 4.71948 2.9435 4.18257 3.30567C3.64565 3.66784 3.22919 4.18216 2.9866 4.78266C2.74402 5.38316 2.68637 6.04244 2.82107 6.67592C2.95576 7.30941 3.27665 7.8882 3.74257 8.33805C4.20849 8.7879 4.79818 9.08829 5.436 9.20069C6.07382 9.31308 6.73067 9.23235 7.32229 8.96885C7.91391 8.70535 8.41331 8.2711 8.75643 7.72181C9.09954 7.17252 9.27072 6.53325 9.248 5.886C9.42 5.832 9.58267 5.76117 9.736 5.6735C9.745 5.78117 9.74967 5.89 9.75 6C9.74995 6.7556 9.52165 7.49355 9.09501 8.11717C8.66836 8.74079 8.06328 9.22098 7.35906 9.49482C6.65483 9.76866 5.8843 9.82337 5.14844 9.65179C4.41259 9.48021 3.74573 9.09033 3.23524 8.53326C2.72476 7.97618 2.39448 7.27788 2.28766 6.52988C2.18085 5.78187 2.30249 5.01904 2.63665 4.34135C2.9708 3.66366 3.50189 3.10272 4.16031 2.73203C4.81873 2.36135 5.57378 2.19821 6.3265 2.264C6.23851 2.41864 6.16727 2.58223 6.114 2.752",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5C9.32843 5 10 4.32843 10 3.5C10 2.67157 9.32843 2 8.5 2C7.67157 2 7 2.67157 7 3.5C7 4.32843 7.67157 5 8.5 5Z",
    fill: "#E4002B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.099ebc0039ed97c3deed1264223b04c7.svg";
export { ForwardRef as ReactComponent };